import _objectSpread from "@babel/runtime/helpers/esm/objectSpread2";
import _classCallCheck from "@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "@babel/runtime/helpers/esm/createClass";
import _inherits from "@babel/runtime/helpers/esm/inherits";
import _createSuper from "@babel/runtime/helpers/esm/createSuper";
import React, { Component } from 'react';
import { SVGIcon } from '@instructure/ui-svg-images';

var _ref = /*#__PURE__*/React.createElement("path", {
  d: "M960.056537,0 L112,363.420495 L112,1079.18021 C112,1469.85159 624,1749.59717 842.572438,1869.00353 C870.04947,1884.0424 892.325088,1896.14134 907.590106,1905.30035 L907.590106,1905.41343 C923.759717,1915.13781 941.85159,1920 960.056537,1920 C978.14841,1920 996.353357,1915.13781 1012.52297,1905.30035 C1027.78799,1896.14134 1050.0636,1884.0424 1077.54064,1869.00353 C1296.11307,1749.59717 1808.11307,1469.85159 1808.11307,1079.18021 L1808.11307,363.420495 L960.056537,0 Z M846.982332,1272.19788 L524.268551,949.484099 L604.325088,869.540636 L846.982332,1112.31095 L1372.32509,586.855124 L1452.38163,666.798587 L846.982332,1272.19788 Z",
  fillRule: "evenodd",
  stroke: "none",
  strokeWidth: "1"
});

var IconStandardsSolid = /*#__PURE__*/function (_Component) {
  _inherits(IconStandardsSolid, _Component);

  var _super = _createSuper(IconStandardsSolid);

  function IconStandardsSolid() {
    _classCallCheck(this, IconStandardsSolid);

    return _super.apply(this, arguments);
  }

  _createClass(IconStandardsSolid, [{
    key: "render",
    value: function render() {
      return /*#__PURE__*/React.createElement(SVGIcon, Object.assign({}, this.props, {
        name: "IconStandards",
        viewBox: "0 0 1920 1920"
      }), _ref);
    }
  }]);

  IconStandardsSolid.displayName = "IconStandardsSolid";
  return IconStandardsSolid;
}(Component);

IconStandardsSolid.glyphName = 'standards';
IconStandardsSolid.variant = 'Solid';
IconStandardsSolid.propTypes = _objectSpread({}, SVGIcon.propTypes);
export default IconStandardsSolid;
export { IconStandardsSolid };